import paths from '../constants/paths';

// This endpoint can store PaymentReference (SID:{rbpkSessionId}|LID:{legacyId}),
// which is how a legacy PaymentTransactions row is matched to its RBPK record.
// A missing reference is written as NULL.
const PAYMENT_REFERENCE_TYPES = new Set(['cash', 'card']);

export const getLegacyAcceptedPaymentPath = (paymentType: string): string =>
	PAYMENT_REFERENCE_TYPES.has(paymentType.toLocaleLowerCase().trim())
		? paths.legacyBpkAdminPostAcceptedPaymentWithPaymentReference
		: paths.legacyBpkAdminPostAcceptedPayment;
